import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import IconOneColor from '../components/icon_1_color.vue';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    values: {
      IconOneColor: {
        component: IconOneColor,
      },
    },
  },
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        primary: '#ee44aa',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  },
});
